import React, { useEffect, useState, useContext } from 'react';
import { getEgsTGarbageEdiDisposalData, getEgsTGarbageEdiDisposalDetail } from '../../lib/api/egs_t_garbage_edi';
import { makeStyles } from '@material-ui/core/styles';
import SpaceRow from '../commons/SpaceRow';
import {
  Button,
  TextField,
  Box,
  Grid,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@material-ui/core';
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarExport,
  jaJP
} from '@mui/x-data-grid-pro'
import { AuthContext } from '../../App';

const useStyles = makeStyles((theme) => ({
  container: {
    borderWidth: 1,
    borderColor: "#CCC",
    borderStyle: "solid",
    marginBottom: 8,
    width: "85vw",
    margin: "auto",
  },
}));

const DisposalCount = () => {
  const { currentUser } = useContext(AuthContext);
  const [selectedExhaustName, setSelectedExhaustName] = useState('');
  const [showFiscalYear, setShowFiscalYear] = useState(false);

  const classes = useStyles();

  // 月の配列を定義
  const months = Array.from({length: 12}, (_, i) => {
    const date = new Date(2024, 3 + i, 1);
    return date.toLocaleString('ja-JP', { month: 'long' });
  });

  // 年度の開始日と終了日を計算する関数
  const getFiscalYearDates = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    
    let startYear, endYear;
    if (currentMonth >= 4) {
      startYear = currentYear;
      endYear = currentYear + 1;
    } else {
      startYear = currentYear - 1;
      endYear = currentYear;
    }

    const startDate = new Date(startYear, 3, 1);
    const endDate = new Date(endYear, 2, 31);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    return {
      start: formatDate(startDate),
      end: formatDate(endDate)
    };
  };

  const { start: defaultStart, end: defaultEnd } = getFiscalYearDates();
  const [dataList, setDataList] = useState([]);
  const [detailData, setDetailData] = useState([]);
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  const [isFilterChanged, setIsFilterChanged] = useState(false);
  const [filter, setFilter] = useState({
    searchDateStart: defaultStart,
    searchDateEnd: defaultEnd,
    wasteName: '',
    invoiceDateType: '0'
  });

  const [selectedMonthData, setSelectedMonthData] = useState(null);
  const [monthlyDetailData, setMonthlyDetailData] = useState([]);
  const [isMonthlyDetailLoading, setIsMonthlyDetailLoading] = useState(false);
  const [selectedCell, setSelectedCell] = useState(null);

  useEffect(() => {
    if (currentUser.traderKbn === '0001000000') {
      setSelectedExhaustName(currentUser.nickname);
      const emissionsdataparams = `${currentUser.traderCd}_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}___${filter.wasteName}_${filter.invoiceDateType}`;
      setIsDetailLoading(true);
      getEgsTGarbageEdiDisposalData(emissionsdataparams)
        .then(res => {
          const dataWithId = res.data.map((item, index) => ({
            id: index,
            ...item
          }));
          setDetailData(dataWithId);
        })
        .catch(error => {
          console.error('Error fetching emissions data:', error);
        })
        .finally(() => {
          setIsDetailLoading(false);
        });
    }
  }, []);
  console.log("detailData",detailData);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setIsFilterChanged(true);
  };

  const startFilter = () => {
    setDetailData([]);
    setSelectedExhaustName('');
    setSelectedMonthData(null);
    setMonthlyDetailData([]);

    if (currentUser.traderKbn === '0001000000') {
      setSelectedExhaustName(currentUser.nickname);
      const emissionsdataparams = `${currentUser.traderCd}_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}___${filter.wasteName}_${filter.invoiceDateType}`;
      setIsDetailLoading(true);
      getEgsTGarbageEdiDisposalData(emissionsdataparams)
        .then(res => {
          const dataWithId = res.data.map((item, index) => ({
            id: index,
            ...item
          }));
          setDetailData(dataWithId);
        })
        .catch(error => {
          console.error('Error fetching emissions data:', error);
        })
        .finally(() => {
          setIsDetailLoading(false);
          setIsFilterChanged(false);
        });
    }
    setShowFiscalYear(true);
  };

  // 集計対象日が変更された時の処理
  const handleInvoiceDateTypeChange = (e) => {
    handleFilterChange({ ...filter, invoiceDateType: e.target.value });
    setDetailData([]); // 廃棄物別月別排出量集計のデータをクリア
    setDataList([]); // 排出事業者名のデータをクリア
  };

  const moveFiscalYear = (direction) => {
    const currentStart = new Date(filter.searchDateStart);
    const currentEnd = new Date(filter.searchDateEnd);
    
    if (direction === 'prev') {
      currentStart.setFullYear(currentStart.getFullYear() - 1);
      currentEnd.setFullYear(currentEnd.getFullYear() - 1);
    } else {
      currentStart.setFullYear(currentStart.getFullYear() + 1);
      currentEnd.setFullYear(currentEnd.getFullYear() + 1);
    }

    setFilter({
      ...filter,
      searchDateStart: currentStart.toISOString().split('T')[0],
      searchDateEnd: currentEnd.toISOString().split('T')[0],
    });
    setIsFilterChanged(true);
    setShowFiscalYear(false);
    setDetailData([]);
    setSelectedMonthData(null);
    setMonthlyDetailData([]);
  };

  const moveToPrevFiscalYear = () => {
    moveFiscalYear('prev');
  };

  const moveToNextFiscalYear = () => {
    moveFiscalYear('next');
  };

  const processWasteData = (data) => {
    const wasteTypes = [...new Set(data.map(item => item.wasteName))];
    const processedData = wasteTypes.map(wasteType => {
      const monthData = data.find(item => item.wasteName === wasteType);
      const unit = monthData?.unitName || '';

      const monthlyData = months.map((month, index) => {
        const monthData = data.filter(item => 
          item.wasteName === wasteType && 
          new Date(item['']).getMonth() === (3 + index) % 12
        );
        return {
          volume: monthData.reduce((sum, item) => sum + parseFloat(item.vol), 0)
        };
      });

      const total = monthlyData.reduce((sum, data) => sum + data.volume, 0);

      const rowData = {
        id: wasteType,
        wasteType,
        unit,
        ...months.reduce((acc, month, index) => {
          acc[month] = monthlyData[index].volume.toFixed(1);
          return acc;
        }, {}),
        total: total.toFixed(1)
      };

      return rowData;
    });

    return processedData;
  };

  const handleMonthClick = async (params) => {
    if (!params.field || params.field === 'wasteType' || params.field === 'unit' || params.field === 'total') {
      return;
    }

    setSelectedCell({ rowId: params.id, field: params.field });
    const wasteType = params.row.wasteType;
    const month = params.field;
    const selectedData = detailData.find(item => 
      item.wasteName === wasteType && 
      new Date(item['']).getMonth() === (3 + months.indexOf(month)) % 12
    );

    if (!selectedData || parseFloat(params.value) === 0) {
      setSelectedMonthData(null);
      setMonthlyDetailData([]);
      return;
    }

    if (selectedData) {
      setSelectedMonthData({ wasteType, month, data: selectedData });
      setIsMonthlyDetailLoading(true);
      try {
        const startYear = new Date(filter.searchDateStart).getFullYear();
        const endYear = new Date(filter.searchDateEnd).getFullYear();
        const monthIndex = months.indexOf(month);
        
        const year = monthIndex >= 9 ? startYear + 1 : startYear;
        const adjustedMonthIndex = (monthIndex + 3) % 12;
        
        const startDate = new Date(year, adjustedMonthIndex, 1);
        const endDate = new Date(year, adjustedMonthIndex + 1, 0);
        
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const monthStart = formatDate(startDate);
        const monthEnd = formatDate(endDate);

        const cleanWasteName = selectedData.wasteName.replace(/pH\d+\.\d+/, '').trim();

        const invoicedetailparams = `${currentUser.traderCd}_${currentUser.traderKbn}_${monthStart}_${monthEnd}___${cleanWasteName}_${filter.invoiceDateType}_`;
        const res = await getEgsTGarbageEdiDisposalDetail(invoicedetailparams);
        const dataWithId = res.data.map((item, index) => ({
          id: index,
          ...item
        }));
        setMonthlyDetailData(dataWithId);
      } catch (error) {
        console.error('Error fetching monthly detail data:', error);
      } finally {
        setIsMonthlyDetailLoading(false);
      }
    }
  };

  const WasteMonthlyGrid = ({ data, selectedExhaustName }) => {
    const processedData = processWasteData(data);

    const getFiscalYearDisplay = () => {
      const startYear = new Date(filter.searchDateStart).getFullYear();
      const endYear = new Date(filter.searchDateEnd).getFullYear();
      return `${startYear}年4月～${endYear}年3月`;
    };
    // 日付のみをフォーマットする関数
    const formatDateOnly = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toISOString().split('T')[0]; // 'YYYY-MM-DD' 形式で返す
    };

    const columns = [
      { 
        field: 'wasteType', 
        headerName: '廃棄物名', 
        width: 260,
        headerAlign: 'center',
        align: 'left'
      },
      ...months.map(month => ({
        field: month,
        headerName: month,
        width: 130,
        headerAlign: 'center',
        align: 'right',
        valueFormatter: (params) => {
          return params.value ? `${params.value}` : '0.0';
        }
      })),
      {
        field: 'total',
        headerName: '合計',
        width: 130,
        headerAlign: 'center',
        align: 'right',
        valueFormatter: (params) => {
          return params.value ? `${params.value}` : '0.0';
        }
      },
      { 
        field: 'unit', 
        headerName: '単位', 
        width: 130,
        headerAlign: 'center',
        align: 'center'
      }
    ];

    const invoiceDetailColumns = [
      {
        field: 'recordNo',
        headerName: 'No.',
        width: 40,
        valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
      },
      { field: 'id', headerName: 'ID', width: 80 },
      { field: 'sect1TransportName', headerName: '収集運搬事業者', width: 200 },
      { field: 'exhaustName', headerName: '排出事業者', width: 200 },      
      { field: 'exhaustDate', headerName: '排出日', width: 100 },
      { field: 'manifestNo', headerName: 'マニフェスト番号', width: 140 },
      { field: 'wasteName', headerName: '廃棄物名称', width: 200 },
      { 
        field: 'amount1', 
        headerName: '数量', 
        width: 80,
        headerAlign: 'right',
        align: 'right'
      },
      { field: 'unitName', headerName: '単位', width: 100 },
      { 
        field: 'packingAmount1', 
        headerName: '荷姿数量', 
        width: 80,
        headerAlign: 'right',
        align: 'right'
      },
      { field: 'packingName', headerName: '荷姿単位', width: 140 },
      { field: 'memo1', headerName: '備考１', width: 140 },
      { field: 'memo2', headerName: '備考２', width: 80 },
      { field: 'memo3', headerName: '備考３', width: 40 },
      { field: 'memo4', headerName: '備考４', width: 40 },
      { field: 'memo5', headerName: '備考５', width: 40 },
      { field: 'lastProcessingTraderName', headerName: '最終処分場', width: 200 },
      // { field: 'createdAt', 
      //   headerName: '作成日', 
      //   width: 100,
      //   valueFormatter: (params) => formatDateOnly(params.value)
      // },
      { field: 'middleEnd', headerName: '中間処理日', width: 100 },
      { field: 'lastProcessingEnd', headerName: '最終処分日', width: 100 },
    ];  

    return (
      <div style={{ marginTop: '20px', width: '100%' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '10px'
        }}>
          <h2>
            廃棄物別月別処分量集計
            {showFiscalYear && `　表示対象：${getFiscalYearDisplay()}`}
            {selectedExhaustName && `　　処理事業者：${selectedExhaustName}`}
          </h2>
        </div>
        <div className={classes.container}>
          <Box sx={{ height: 412, width: '100%' }}>
            <DataGridPro
              sx={{
                ...styles.grid2,
                '& .MuiDataGrid-cell': {
                  '&.selected': {
                    backgroundColor: '#e3f2fd !important',
                    '&:hover': {
                      backgroundColor: '#bbdefb !important',
                    },
                  },
                },
              }}
              rows={processedData}
              columns={columns}
              density="compact"
              components={{
                Toolbar: CustomToolbar,
              }}
              showColumnRightBorder
              showCellRightBorder
              localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
              onCellClick={handleMonthClick}
              getCellClassName={(params) => {
                if (selectedCell && params.id === selectedCell.rowId && params.field === selectedCell.field) {
                  return 'selected';
                }
                return '';
              }}
            />
          </Box>
        </div>
        {selectedMonthData && (
          <div style={{ marginTop: '20px' }}>
            <h3>
              {selectedMonthData.wasteType} - {selectedMonthData.month}の詳細
            </h3>
            <div className={classes.container}>
              <Box sx={{ height: 500, width: '100%' }}>
                <DataGridPro
                  sx={styles.grid3}
                  columns={invoiceDetailColumns}
                  rows={monthlyDetailData}
                  loading={isMonthlyDetailLoading}
                  density="compact"
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  showColumnRightBorder
                  showCellRightBorder
                  localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                />
              </Box>
            </div>
          </div>
        )}
      </div>
    );
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          csvOptions={{
            fileName: 'Sdgs12_InvoiceData',
            delimiter: ',',
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    );
  }

  return (
    <>
      <h1>処分量集計（{new Date().toLocaleString()})　　　
        <Button
          onClick={() => window.location.reload()}
          color="primary"
          style={{ marginLeft: '20px' }}
        >
          最新（再読み込み）
        </Button>
      </h1>
      {currentUser.traderKbn === '0001000000' && (
        <>
          <Grid container spacing={2}>
            <Grid item xs style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}>
              <Box p={1} display={"flex"} alignItems={"center"}>
                <Typography variant="h6" style={{ fontWeight: 700 }}>集計年度：</Typography>
              </Box>
              <Button onClick={moveToPrevFiscalYear} style={{ marginLeft: 8 }}>◀</Button>
              <TextField
                value={filter.searchDateStart}
                onChange={e => handleFilterChange({ ...filter, searchDateStart: e.target.value })}
                type="date"
                InputLabelProps={{ shrink: true }}
                disabled
                InputProps={{
                  style: { color: '#000000' }
                }}
              />
              <div style={{ marginLeft: 16, marginRight: 16 }}> ～ </div>
              <TextField
                value={filter.searchDateEnd}
                onChange={e => handleFilterChange({ ...filter, searchDateEnd: e.target.value })}
                type="date"
                InputLabelProps={{ shrink: true }}
                disabled
                InputProps={{
                  style: { color: '#000000' }
                }}
              />
              <Button onClick={moveToNextFiscalYear} style={{ marginLeft: 8 }}>▶</Button>
              <Typography variant="h6" style={{ fontWeight: 700, marginLeft: '16px' }}>　集計対象日：</Typography>
              <Typography variant="h6" style={{ marginLeft: '8px' }}>最終処分日</Typography>
              <Button
                variant='contained'
                color='primary'
                onClick={startFilter}
                style={{ marginLeft: 24 }}
                disabled={!isFilterChanged}
              >
                データ表示
              </Button>
            </Grid>
          </Grid>
          <SpaceRow height={10} />
          <WasteMonthlyGrid data={detailData} selectedExhaustName={selectedExhaustName} />
        </>
      )}
      <SpaceRow height={20} />
    </>
  );
};

const styles = {
  grid2: {
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#4169e1',
      color: '#fff',
    }
  },
  grid3: {
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#a52a2a',
      color: '#fff',
    }
  }
};

export default DisposalCount;